import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';

export const httpUpdateLogos = () => returnAction(ActionEnum.HTTP_UPDATE_LOGOS);
